import { INotification } from '@core/models';

export interface State {
  addError: string;
  addLoading: boolean;
  removeError: string;
  removeLoading: boolean;
  resetError: string;
  resetLoading: boolean;
  notifications: INotification[];
  notificationsError: string;
  notificationsLoading: boolean;
}

export const initialState: State = {
  addError: '',
  addLoading: false,
  removeError: '',
  removeLoading: false,
  resetError: '',
  resetLoading: false,
  notifications: [],
  notificationsError: '',
  notificationsLoading: false,
};
